import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import SettingsPage from "@/pages/admin/Settings";
import Legal from "@/pages/Legal";
import LegalAdmin from "@/pages/admin/LegalAdmin";
import Essap from "@/pages/Essap";
import EssapAdmin from "@/pages/admin/EssapAdmin";
import EssapShell from "@/components/site/EssapShell";
import EssapCategory from "@/pages/EssapCategory";
import EssapPostPage from "@/pages/EssapPost";
import EssapPosts from "@/pages/admin/EssapPosts";
import PublicLayout from "@/components/site/PublicLayout";
import AdminLayout from "@/components/admin/AdminLayout";
import Home from "@/pages/Home";
import Verify from "@/pages/Verify";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Login from "@/pages/Login";
import Dashboard from "@/pages/admin/Dashboard";
import APList from "@/pages/admin/APList";
import Articles from "@/pages/admin/Articles";
import Users from "@/pages/admin/Users";
import Account from "@/pages/admin/Account";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/verification" element={<Verify />} />
              <Route path="/verification/:cnap" element={<Verify />} />
              <Route path="/communiques" element={<News />} />
              <Route path="/communiques/:id" element={<NewsDetail />} />
              <Route path="/mention-legale" element={<Legal />} />
              <Route path="/essap" element={<EssapShell />}>
                <Route index element={<Essap />} />
                <Route path="publication/:id" element={<EssapPostPage />} />
                <Route path=":categorie" element={<EssapCategory />} />
              </Route>
            </Route>
            <Route path="/connexion" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="ap" element={<APList />} />
              <Route path="communiques" element={<Articles />} />
              <Route path="administrateurs" element={<Users />} />
              <Route path="compte" element={<Account />} />
              <Route path="parametres" element={<SettingsPage />} />
              <Route path="mention-legale" element={<LegalAdmin />} />
              <Route path="essap" element={<EssapAdmin />} />
              <Route path="essap/publications" element={<EssapPosts />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
